import { useLayoutEffect, useRef, useState } from 'react'

export function useLayoutHeaderUserMenuWidth() {
  const userMenuRef = useRef(null)

  const [userMenuWidth, setUserMenuWidth] = useState(0)

  useLayoutEffect(() => {
    if (userMenuRef.current) {
      const width = userMenuRef.current.offsetWidth

      setUserMenuWidth(width)
    }
  }, [userMenuRef])

  return { userMenuRef, userMenuWidth }
}
